// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290404/js/" + chunkId + "." + {"44":"2d86cc07","225":"12b370b5","481":"909f0d43","486":"15b53f0e","770":"fa1c6de8"}[chunkId] + ".0.3869383744153837.chunk.js";
};